import { mapState } from 'vuex'

import brandingMixin from '@/mixins/branding'
import detectMobileMixin from '@/mixins/detectMobile'

import FullStickyBg from '@/components/fullStickyBg/fullStickyBg'

export default {
	mixins: [brandingMixin, detectMobileMixin],
	components: {
		appFullStickyBg: FullStickyBg
	},
  data () {
    return {
			ytFrame: null,
			player: null,
			volumeSlider: null,
			seekSlider: null,
			processing: null,
			hovering: null,
			displayCurrentTime: '00:00',
			currentTime: '00:00',
			durationTime: '00:00',
			stopUpdateTime: true,
			stopMuted: true,
			isPlaying: false,
			isMuted: true,//false,
			isFullScreen: false,
			isVisibleTooltip: false,
			lastVolumeState: 0,//100,
			seekValue: 0,
			volumeValue: 0,//100,
			controlsIsVisible: true,
			playerVars: {
				autoplay: 0,//1,
				controls: 0,
				rel: 0,
				allowfullscreen: 1,
				loop: 1,
				origin: window.location.origin
      }
    }
  },
  computed: {
		...mapState('tours', ['video']),
    videoId () {
			const url = 
				this.video && this.isBranded
					? this.video.youtubeUrlBranded
					: this.video.youtubeUrlUnbranded

      if (url) {
        return this.$youtube.getIdFromUrl(url)
			}
			return
		},
		tooltipPosition () {
			const sliderWidth = this.seekSlider && parseInt(this.seekSlider.clientWidth) - 14

			return (parseInt(this.seekValue) / 100) * sliderWidth
		}
  },
  methods: {
		setFullscreenState () {
			const el = document

			if(el.fullscreenElement || 
				el.mozFullScreenElement || 
				el.msFullscreenElement ||
				el.webkitFullscreenElement
			) {
				this.isFullScreen = true
			} else {
				this.isFullScreen = false
			}
		},
		timeToHms (time) {
			const h = Math.floor(time / 3600)
			const m = Math.floor(time % 3600 / 60)
			const s = Math.floor(time % 3600 % 60)
	
			const hDisplay = h > 0 ? `${(`${h}`.padStart(2, 0))}:` : ''
			const mDisplay = m > 0 ? `${(`${m}`.padStart(2, 0))}:` : '00:'
			const sDisplay = s > 0 ? `${s}`.padStart(2, 0) : '00'

			return `${hDisplay}${mDisplay}${sDisplay}`
		},
		async getMute () {
			setTimeout( async () => {
				this.isMuted = await this.player.isMuted()
			}, 100)
		},
		async getDurationTime () {
			this.durationTime = this.timeToHms(await this.player.getDuration())
		},
		async updateTime () {
			this.processing = setInterval( async () => {
				if (!this.stopUpdateTime) {
					const time = await this.player.getCurrentTime()
						
					this.currentTime = this.timeToHms(time + 1)

					this.updateSeekSlider(time)
				}
			}, 100)
		},
		async updateSeekSlider (time) {
			const totalTime = await this.player.getDuration()
			const progress = (time / totalTime) * 100

			const val = progress < 100 ? progress : 100

			this.seekSlider.value = val
			this.seekValue = val
		},
		// setControlsVisible (state) {
		// 	this.controlsIsVisible = state
		// },
		// setHoveringTimer (delay) {
		// 	this.hovering = setTimeout(() => {
		// 		this.setControlsVisible(false)
		// 	}, delay || 2000)
		// },
    onPlay() {
			this.player.playVideo()
			
			//this.setControlsVisible(false)
		},
		onPause() {
			this.player.pauseVideo()

			//this.setControlsVisible(true)
			//clearInterval(this.hovering)
		},
		onPlayOrPause() {
			// if (this.isMobile()) {
			// 	return false
			// }

			if (this.isPlaying) {
				this.onPause()
			} else {
				this.onPlay()
			}
		},
		onMute () {
			this.player.mute()

			this.stopMuted = false
			this.isMuted = true
			this.volumeSlider.value = 0
			this.volumeValue = 0
		},
		onUnmute () {
			this.player.unMute()

			this.isMuted = false

			this.volumeSlider.value = this.lastVolumeState
			this.volumeValue = this.lastVolumeState
		},
		onVolumeChange (event) {
			this.lastVolumeState = event.target.value
		},
		onVolumeDragging (event) {
			const val = parseInt(event.target.value)

			this.player.setVolume(val)
			this.volumeValue = val

			if (val === 0) {
				this.stopMuted = false

				this.onMute()
			} else if (val > 0 && !this.stopMuted) {
				this.stopMuted = true
				this.isMuted = false

				this.player.unMute()
			}
		},
		async onSeekDragging (event) {
			this.stopUpdateTime = true
			this.isVisibleTooltip = true

			this.onPause()

			const updatedTime = await this.player.getDuration() * (event.target.value / 100)
				
			this.displayCurrentTime = this.timeToHms(updatedTime + 1)
			this.seekValue = event.target.value
		},
		async onSeek (event) {
			this.isVisibleTooltip = false

			this.player.playVideo()

			const newTime = await this.player.getDuration() * (event.target.value / 100)

			this.player.seekTo(newTime)
		},
		onOpenFullScreen () {
			const el = this.ytFrame

			if (el.requestFullscreen) {
				el.requestFullscreen()
			} else if (el.mozRequestFullScreen) {
				el.mozRequestFullScreen() // Firefox
			} else if (el.webkitRequestFullscreen) {
				el.webkitRequestFullscreen() // Chrome and Safari
			}
		},
		onCloseFullScreen () {
			if (document.exitFullscreen) {
				document.exitFullscreen()
			} else if (document.mozExitFullscreen) {
				document.mozExitFullscreen() // Firefox
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen() // Chrome and Safari
			}
		},
		// onControlsHover () {
		// 	if (this.isMobile()) {
		// 		return false
		// 	}

		// 	this.setControlsVisible(true)
		// },
		// onControlsTouch () {
		// 	if (!this.isMobile()) {
		// 		return false
		// 	}

		// 	clearInterval(this.hovering)

		// 	this.setHoveringTimer(3000)
		// },
		// onPlayerTouch () {
		// 	if (!this.isMobile()) {
		// 		return false
		// 	}

		// 	if (this.controlsIsVisible) {
		// 		this.onPlay()
		// 	}

		// 	this.setControlsVisible(true)

		// 	clearInterval(this.hovering)

		// 	this.setHoveringTimer(3000)
		// },
		// onPlayerHover () {
		// 	if (this.isMobile()) {
		// 		return false
		// 	}

		// 	this.setControlsVisible(true)

		// 	clearInterval(this.hovering)

		// 	if (!this.isPlaying) {
		// 		return false
		// 	}

		// 	this.setHoveringTimer()
		// },
		// onPlayerUnhover () {
		// 	if (this.isMobile()) {
		// 		return false
		// 	}

		// 	if (this.isPlaying) {
		// 		this.setControlsVisible(false)
		// 	}

		// 	clearInterval(this.hovering)
		// },
		ready () {
			this.getMute()
			this.getDurationTime()
		},
		ended () {
			this.onPlay()
		},
		playing() {
			this.isPlaying = true
			this.stopUpdateTime = false

			clearInterval(this.processing)
			this.updateTime()
    },
    paused() {
			this.isPlaying = false

			clearInterval(this.processing)
    }
  },
  mounted () {
		this.ytFrame = this.$refs.ytFrame
		this.player = this.$refs.ytPlayer.player
		this.volumeSlider = this.$refs.volumeSlider
		this.seekSlider = this.$refs.seekSlider

		document.addEventListener('fullscreenchange', this.setFullscreenState)
	},
	destroyed () {
    document.removeEventListener('fullscreenchange', this.setFullscreenState)
  }
}
